export const liantisColors = {
  palette_primary: {
    125: '#7843A5',
    100: '#7843A5',
    0: '#F9F2FF'
  },

  palette_blue: {
    100: '#7843A5',
    5: '#F2E4FF',
    0: '#F9F2FF'
  },
  blue: {
    50: '#F3EDF8',
    100: '#DDCCEA',
    200: '#C6ACDD',
    300: '#B08BD0',
    400: '#9A6AC3',
    500: '#844AB5',
    600: '#6A3B91',
    700: '#4F2C6D',
    800: '#351D49',
    900: '#1A0F24'
  },
  alert: {
    50: '#FBE9EA',
    100: '#F5C2C3',
    200: '#EE9B9D',
    300: '#E77377',
    400: '#E14C51',
    500: '#DA252A',
    600: '#AE1E22',
    700: '#831619',
    800: '#570F11',
    900: '#2C0708'
  },
  warning: {
    50: '#FBF0EA',
    100: '#F3D4C3',
    200: '#ECB89D',
    300: '#E49D77',
    400: '#DC8151',
    500: '#D5652A',
    600: '#AA5122',
    700: '#803D19',
    800: '#552811',
    900: '#2B1408'
  },
  success: {
    50: '#E7FDF5',
    100: '#BDFAE4',
    200: '#92F6D3',
    300: '#68F3C2',
    400: '#3EEFB1',
    500: '#13ECA0',
    600: '#0FBD80',
    700: '#0B8E60',
    800: '#085E40',
    900: '#042F20'
  },
  gray: {
    50: '#EFF1F5',
    100: '#D3D8E3',
    200: '#B7BFD1',
    300: '#9BA5BF',
    500: '#64739B',
    600: '#505C7C',
    700: '#3C455D',
    800: '#282E3E',
    900: '#14171F'
  },
  primary: {
    50: '#F3EDF8',
    100: '#DDCCEA',
    200: '#C6ACDD',
    300: '#B08BD0',
    400: '#9A6AC3',
    500: '#844AB5',
    600: '#6A3B91',
    700: '#4F2C6D',
    800: '#351D49',
    900: '#1A0F24'
  }
};

export const liantisSemanticColors = {
  border: {
    divider: '#EAEAEB'
  },
  text: {
    default: '#6A6E77'
  }
};
